import Desktop from "./gui/Desktop";

$(() => {
    new Desktop(document.body);
});
